export default __webpack_public_path__ + "static/media/jump@3x.5e9c8559.png";